import React, { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Navigate, Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { formatApiErrorDetail } from "@/lib/api";

function SofmatAccess({ children }) {
  return <main className="sf-auth sf-auth-app">
    <aside className="sf-auth-visual" aria-label="SOFMAT">
      <a className="sf-auth-logo" href="https://staging.sofmat.it/"><span className="sf-auth-mark" aria-hidden="true">S</span><strong>SOFMAT</strong></a>
      <span className="sf-auth-tagline">LA RETE DELL’OFFICINA</span>
      <div className="sf-auth-promise"><span className="sf-auth-eyebrow">IL TUO ECOSISTEMA INDUSTRIALE</span><h2>Le tue competenze.<br />Una rete di possibilità.</h2><p>Persone, strumenti e opportunità per il lavoro in officina.</p><div className="sf-auth-lines" aria-hidden="true"><i /><i /><i /></div></div>
      <div className="sf-auth-bottom"><span className="sf-auth-status-dot" aria-hidden="true" /> Il tuo spazio di lavoro SOFMAT</div>
    </aside>
    <section className="sf-auth-card">{children}</section>
  </main>;
}

export default function Login() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState(""), [password, setPassword] = useState(""), [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  if (user) return <Navigate to="/dashboard" replace />;
  if (window.location.hostname === "app.sofmat.it") return <SofmatAccess>
    <div data-testid="sofmat-sso-login">
      <div className="sf-auth-intro"><span className="sf-auth-platform">QuoteOS</span><h2>Accedi al tuo spazio</h2><p>Accedi alla preventivazione industriale con il tuo account aziendale SOFMAT.</p></div>
      <a className="sf-auth-button" href="/api/auth/sofmat/start?company_id=1">Entra in QuoteOS con SOFMAT</a>
      <p className="sf-auth-note">La prova interna di QuoteOS utilizza il tuo account aziendale SOFMAT. Non serve una seconda password.</p>
      <p className="sf-auth-note">Accesso riservato agli utenti autorizzati dell'azienda pilota. Il login non avvia letture o addebiti API. La prova non costituisce apertura commerciale.</p>
      <a className="sf-auth-return" href="https://staging.sofmat.it/il-tuo-spazio/?sf_view=home">Torna al portale SOFMAT</a>
    </div>
  </SofmatAccess>;
  const onSubmit = async e => {
    e.preventDefault(); setLoading(true);
    try { await login(email, password); toast.success("Accesso effettuato"); navigate("/dashboard"); }
    catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message); }
    finally { setLoading(false); }
  };
  return <SofmatAccess>
    <div className="sf-auth-intro"><span className="sf-auth-platform">QuoteOS · Staging</span><h2>Accedi al tuo spazio</h2><p>Ambiente di staging: usa le credenziali della tua officina.</p></div>
    <form onSubmit={onSubmit}>
      <div className="sf-auth-field"><Label htmlFor="email">Email</Label><Input id="email" type="email" autoComplete="username" value={email} onChange={e => setEmail(e.target.value)} required /></div>
      <div className="sf-auth-field"><Label htmlFor="password">Password</Label><Input id="password" type="password" autoComplete="current-password" value={password} onChange={e => setPassword(e.target.value)} required /></div>
      <Button className="sf-auth-button" type="submit" disabled={loading}>{loading ? "Accesso..." : "Accedi"}</Button><Link to="/register" className="sf-auth-return">Crea account azienda</Link>
    </form>
  </SofmatAccess>;
}
